import './App.css';
import heroImg from './image/image.png';
import DoshaWellness from './components/DoshaWellness';

function App() {
  return (
    <div className="App">
      <div style={{textAlign: "center"}}>
      <img src={heroImg} alt="Hero" style={{width: "50%",height: "60%"}}/>
      </div>
      <DoshaWellness />
    </div>
  );
}

export default App;
